/**
 * `URL.canParse` for browsers older than Chrome 120 / Safari 17, where `@braintree/sanitize-url`
 * otherwise throws on every call.
 *
 * Dependency-free: the Knockout bundle compiles it too.
 */
export function polyfillUrlCanParse(): void {
  if (typeof URL.canParse === 'function') {
    return;
  }

  URL.canParse = (url: string | URL, base?: string | URL): boolean => {
    try {
      new URL(url, base);
      return true;
    } catch {
      return false;
    }
  };
}
